import { DeviceInfo } from '@ezugi/utils/helpers/deviceInfo';

export function setViewportSizeVariables() {
  if (document.documentElement.scrollTop !== 0) window.scrollTo(0, 0);

  const { innerHeight, innerWidth } = window;
  const visualHeight = visualViewport?.height || innerHeight;

  const docStyle = document.documentElement.style;

  innerWidth && docStyle.setProperty(
    '--innerWidth',
    `${innerWidth}px`,
  );

  visualHeight && docStyle.setProperty(
    '--innerHeight',
    `${visualHeight}px`,
  );

  if (DeviceInfo.isIOS26) {
    const computeIOS26ViewportTopOffset = () => {
      const spaceFromViewportToBody = document.body.offsetHeight - window.innerHeight;

      const computedStyle = getComputedStyle(document.documentElement);

      const safeAreaTop = Math.max(
        spaceFromViewportToBody || 0,
        parseFloat(computedStyle.getPropertyValue('--safe-area-inset-top') || '0'),
      );

      docStyle.setProperty('--ios-26-viewport-top-offset', `${safeAreaTop}px`);
    };

    setTimeout(computeIOS26ViewportTopOffset, 500);
  }
}
